module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAMFBMVEUAAAD///////////////////////////////////////////////////////////87TQQwAAAAD3RSTlMADsfaz2tRBvXz1RtvUwetB8uJAAAASklEQVQY02PAD0o1J4XD2Nz+//9/2QDllHxOFLNfB+XEGzIwSP2BcvQvMDCwfYJy+gUYGBh/QDn/IRQm5z8UoHEQqmjJweMCPAAAKjI/Ui21DZIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lock2.png
// module id = 456
// module chunks = 0 1 2 3 4 5 6 7